module.exports = __webpack_public_path__ + "img/author_image.60447e6.jpg";